<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top: 5%">
                            <CCol sm="12" style="width: 50%;background-size: cover; margin: auto;" class="d-sm-down-none">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-20px-500 font-Montserrat ">  <img src="../assets/img/all/logo.png" width="40px" class="mr-2"/>MyReport</h3>
                                        <h3 class="custom-32px-500 text-center font-color-171717 mt-4">Log In </h3>
                                        <p class="custom-16px-400">Log in using your credentials to access the secure portal.</p>
                                    </div>
    
                                            <div v-if="this.ErrorLogin == true" class="ml-4 mr-4 mt-4">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                                                </CAlert>
                                            </div>
                                            <div class="mt-3">
                                                <strong class="text-left mt-2 mb-2">Email</strong>
                                                <input type="text" class="custom-input-app mb-2 mt-2" v-model="userEmail" />
    
                                                <strong class="text-left mt-4 mb-2">Password</strong>
                                                <input type="password" class="custom-input-app mb-4 mt-2" v-model="userPassword" />
    <CRow>
        <CCol sm="6">  
            <!-- <input type="checkbox" class="mr-3 mb-3" />Remember me -->
        </CCol>
        <CCol sm="6" class="font-color-453E8E text-right custom-16px-500"><label @click="OpenForgot()">Forgot Password</label></CCol>
    </CRow>
                                              
    
                                            </div>
                                            <div class="text-center mt-3 mb-5">
                                                <span class="bg-453E8E custom-border-radius" v-on:click="trylogin">Continue</span>
                                            </div>
                                            <p class="text-center" v-on:click="GoToSignUp()">New on our platform?<label class="font-color-453E8E ml-2">Create an account</label></p>
                                            <!-- <p class="text-center" v-on:click="GoToSignUp()">New on our platform?<label class="font-color-928AFD ml-2">Create an account</label></p>
                                            <img src="../assets/img/signwith.png" style="max-width:100%" class="mb-2">
    
                                            <div class="custom-border-line mt-4">
                                                <div class="inline-container" v-on:click="login">
                                                    <img src="../assets/img/google-symbol1.png" class="ml-2" alt="Search Button" style="max-width:20px" />
                                                    <span class="text-center" style="margin-left:40%">{{ lblGoogle }}</span>
    
                                                </div>
                                            </div> -->
                                            <br /><br />
                                            <div style="clear:both"></div>
                                          
                                </CCard>
                            </CCol>




                            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;margin: 70px 0px;padding: 0px;" class="d-md-none">
                                <CCard class="border-radius-16px p-4 mb-5">
                                    <div class="text-center">
                                        <h3 class="custom-20px-500 font-Montserrat ">  <img src="../assets/img/all/logo.png" width="40px" class="mr-2"/>Interviewrr</h3>
                                        <h3 class="custom-32px-500 text-center font-color-171717">Log In </h3>
                                        <p class="custom-16px-400">Log in using your credentials to access the secure portal.</p>
                                    </div>
    
                                  
                                            <div v-if="this.ErrorLogin == true" class="ml-4 mr-4 mt-4">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                                                </CAlert>
                                            </div>
                                            <div class="mt-3">
                                                <strong class="text-left mt-2 mb-2">Email</strong>
                                                <input type="text" class="custom-input-app mb-2" v-model="userEmail" />
    
                                                <strong class="text-left mt-4 mb-2">Password</strong>
                                                <input type="password" class="custom-input-app mb-4" v-model="userPassword" />
    <CRow>
        <CCol sm="6">  
            <!-- <input type="checkbox" class="mr-3 mb-3" />Remember me -->
        </CCol>
        <CCol sm="6" class="font-color-453E8E text-right custom-16px-500"><label @click="OpenForgot()">Forgot Password</label></CCol>
    </CRow> <div class="text-center mt-5 mb-5">
                                                <span class="bg-453E8E custom-border-radius" v-on:click="trylogin">Continue</span>
                                            </div>
                                              
    
                                            </div>
                                            <p class="text-center" v-on:click="GoToSignUp()">New on our platform?<label class="font-color-453E8E ml-2">Create an account</label></p>
                                            <!-- <img src="../assets/img/signwith.png" style="max-width:100%" class="mb-2"> -->
    
                                            <!-- <div class="custom-border-line mt-4">
                                                <div class="inline-container" v-on:click="login">
                                                    <img src="../assets/img/google-symbol1.png" class="ml-2" alt="Search Button" style="max-width:20px" />
                                                    <span class="text-center" style="margin-left:40%">{{ lblGoogle }}</span>
    
                                                </div>
                                            </div> -->
                                            <br /><br />
                                            <div style="clear:both"></div>
                                    
                                </CCard>
                            </CCol>

                        </div>
    
    
    
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100px" src="../assets/img/success.png" />
                    <h3 class="custom-32px-500">Success!</h3>
                    <h3 class="custom-18px text-center">Your account is succesfully registered</h3>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/all/banner.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,



            name: "",
            email: "",
            phone: "",
            password: "",
            selectedUser: this.$route.query.type === 'individual' ? 'individual' : 'company',
            website: "",
            detail: "",



            userOptions: [{

                id: 1,
                UserType: "Candidate",


            }, ],
            isLanguagePopupVisible1: false,
            isLanguagePopupVisible2: false,

            userEmail: "",
            userPassword: "",


            ErrorLogin: false,
            Message: "",

            lblGoogle: "Google",

        };
    },
    created() {
        // Check if the 'type' query parameter is present in the URL
        const type = this.$route.query.type;
        if (type === 'individual') {
            // If the type is 'individual', set the selectedUser to 'individual'
            this.selectedUser = 'individual';
        } else if (type === 'company') {
            // If the type is 'company', set the selectedUser to 'company'
            this.selectedUser = 'company';
        } else {
            // Handle other cases, if necessary
        }
    },


    methods: {
        updateSelection(selection) {
            this.selectedUser = selection;
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GotoHowItWork() {
            this.$router.push("HowItWork");
        },
        closePopup() {
            this.isLanguagePopupVisible1 = false;
        },

        trylogin() {
            this.ErrorLogin = false;

            const formData = new FormData();

            if (this.userEmail === "" || this.userPassword === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("Email", this.userEmail);
                formData.append("Password", this.userPassword);

                this.$API
                    .post(this.$LoginToken, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.ErrorLogin = true;
                        }
                        if (response.status == 200) {

                            if (response.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    //  const userId = response.data.data.userType;
                                    // console.log("userid", userId);
                                    if (response.data.data.userType === '-') {
                                        this.$router.push("HowItWork");
                                    } else if (response.data.data.userType === 'individual') {
                                        this.$router.push("HowItWork");
                                    } else {
                                        this.$router.push("HowItWork");
                                    }

                                }
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.ErrorLogin = true;
                            }
                        } else {
                            this.Loading = false;
                            this.ErrorLogin = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.ErrorLogin = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        registerAccount() {

            const formData = new FormData();

            if (this.Name === "" || this.Email === "" || this.Phone === "" || this.Password === "") {
                this.Error = true;
                this.Message = "Please fill up the form !";
            } else {
                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.$route.query.phone);
                formData.append("userType", this.selectedUser);
                formData.append("password", this.password);
                formData.append("website", this.website);
                formData.append("detail", this.detail);
                formData.append("countryId", this.$route.query.countryid);




                this.$API
                    .post(this.$Register, formData, { withCredentials: true })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {

                            if (response.data.status !== 400) {

                                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                    this.isLanguagePopupVisible1 = true;
                                }


                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                    });
            }
        },
        GoToHomeUser() {
            this.$router.push("/Dashboard");
        },
        async login() {
            this.lblGoogle = "Google";
            try {
                var googleuser = await this.$gAuth.signIn(); // Wait for signIn() method to complete
                this.isLogin = this.$gAuth.isAuthorized; // Update isLogin status after successful signIn
                console.log('Is user logged in?', this.isLogin);
                var idToken = googleuser.getAuthResponse().id_token;
                console.log("getProfile" + googleuser.getBasicProfile());
                console.log("auth" + googleuser.getAuthResponse());
                console.log("auth" + this.$gAuth.GoogleAuth.currentUser.get().getAuthResponse());



                
                // If the user is logged in, retrieve the user profile to access the email
                if (this.isLogin) {
                    console.log('ID Token:', idToken);

                    var authResponse = googleuser.getAuthResponse();
            var accessToken = authResponse.access_token;
            var idToken = authResponse.id_token;

            console.log('ID Token:', idToken);
            console.log('Access Token:', accessToken);

            // Verify if the token includes the scope
            await this.verifyScopes(accessToken);

            // Fetch user phone and address info
            const userInfo = await this.getUserInfo(accessToken);
            console.log('User Info:', userInfo);

            const userName = userInfo.displayName;
                    this.getUserEmail(idToken, userName);
                }
            } catch (error) {
                console.error('Error during login:', error);
            }
        },
        async verifyScopes(accessToken) {
    try {
        const response = await fetch(`https://www.googleapis.com/oauth2/v3/tokeninfo?access_token=${accessToken}`);
        const tokenInfo = await response.json();

        console.log('Token Info:', tokenInfo);

        if (tokenInfo.scope.includes('https://www.googleapis.com/auth/user.phonenumbers.read')) {
            console.log('Scope is present in the token.');
        } else {
            console.error('Scope is missing in the token.');
        }
    } catch (error) {
        console.error('Error verifying scopes:', error);
    }
},
async getUserInfo(accessToken) {
    try {
        const response = await fetch('https://people.googleapis.com/v1/people/me?personFields=phoneNumbers,addresses,emailAddresses,names', {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        const userData = await response.json();
        
        console.log('User Data:', userData);

        const phoneNumber = userData.phoneNumbers?.length > 0 ? userData.phoneNumbers[0].value : 'No phone number available';
        const country = userData.addresses?.length > 0 ? userData.addresses[0].country : 'No country information available';
        const displayName = userData.names?.length > 0 ? userData.names[0].displayName : 'No display name available';

        return { phoneNumber, country, displayName };
    } catch (error) {
        console.error('Error fetching user info:', error);
        return { phoneNumber: 'Error', country: 'Error' };
    }
},
        async getUserEmail(idToken, username) {
            this.lblGoogle = "Google";
            try {
                const response = await this.$API.get(this.$GetTokenEmail + "?idToken=" + idToken);
                if (response.status === 200) {
                    this.user = response.data;
                    this.SetSession(idToken, this.user, username);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },

        async SetSession(idToken, user, username) {
            this.lblGoogle = "Processing";
            console.log("username:" + username)
            try {
                const response = await this.$API.get(this.$InsertSession + "?idToken=" + idToken);
                console.log("Response:", response);
                if (response.status === 202) {

                //this.$router.push("JoinUs?email=" + this.user);
               this.registerAccountGoogleUser(user,username, idToken);
           
               this.SetSession(idToken, user, username);
            

                } else if (response.status === 200) {
                    this.lblGoogle = "Processing";
                    const userData = response.data;
                    console.log("User Data:", userData);
                    const userType = response.data.data.userType;
                    console.log("User Type:", response.data.data.userType);
                    await this.delay(5000);
                    //this.$router.push("Profile");
                    const isAuth = await this.UserAuth();
            if (isAuth) {
                if (
                                    this.$route.query.targetUrl != "" &&
                                    (this.$route.query.targetUrl != null) &
                                    (this.$route.query.targetUrl != undefined)
                                ) {
                                    this.$router.push(this.$route.query.targetUrl);
                                } else {
                                  
                                    //  const userId = response.data.data.userType;
                                    // console.log("userid", userId);
                                    if (response.data.data.userType === '-') {
                                        this.$router.push("HowItWork");
                                    } else if (response.data.data.userType === 'individual') {
                                        this.$router.push("HowItWork");
                                    } else {
                                        this.$router.push("HowItWork");
                                    }

                                }
            } else {
                this.lblGoogle = "Google";
                this.GoToLogin();
            }
                    
                    console.error("Failed to fetch user information:", response);
                } else {
                    this.lblGoogle = "Google";
                    // Handle other status codes
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
},
        OpenForgot()
        {
            this.$router.push("ForgotPassword");
        },
        GoToSignUp()
        {
            this.$router.push("JoinUs");

        },
        registerAccountGoogleUser(user,username, idtoken) {

const formData = new FormData();
    formData.append("name", username);
    formData.append("email", user);
    formData.append("userType", 'individual');




    this.$API
        .post(this.$Register, formData, { withCredentials: true })
        .then((response) => {
            if (response.data.status === 400) {
                this.Loading = false;
                this.Message = response.data.message;
                this.Error = true;

            }
            if (response.status == 200) {

                alert('Please update your phone number on your profile');
               
                if (response.data.status !== 400) {

                    if (
                        this.$route.query.targetUrl != "" &&
                        (this.$route.query.targetUrl != null) &
                        (this.$route.query.targetUrl != undefined)
                    ) {
                        this.$router.push(this.$route.query.targetUrl);
                    } else {
                        this.$router.push("Profile");
                    }


                } else {
                    this.Loading = false;
                    this.Message = response.data.message;
                    this.Error = true;
                }
            } else {
                this.Loading = false;
                this.Error = true;
                this.Message = response.data.message;
            }
        })
        .catch((error) => {
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
        });
},


    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}
.c-header.c-header-fixed {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1029;
  background: transparent;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>